import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { SessionConflictCheckRequest } from "../contracts/SessionConflictCheckRequest";
import { SessionConflictsResponse } from "../contracts/SessionConflictsResponse";
import { SessionConflicts } from "../models/SessionConflict";

const toHHMM = (time: string): string => time.split(":").slice(0, 2).join(":");

/**
 * Advisory overlap check for the session being configured. The result is consumed
 * locally by the form (via unwrap) — no shared state is written.
 */
export const checkSessionConflicts = createAsyncThunk<
  SessionConflicts,
  SessionConflictCheckRequest,
  { rejectValue: ApiErrorResponse }
>("sessions/checkConflicts", async (request, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post<SessionConflictsResponse>(
      "/bookings/conflicts",
      request
    );
    return {
      hasMore: response.data.hasMore,
      conflicts: response.data.conflicts.map((c) => ({
        date: c.date,
        time: toHHMM(c.time),
        conflictingSessionId: c.conflictingSessionId,
        conflictingTitle: c.conflictingTitle,
        conflictingTime: toHHMM(c.conflictingTime),
      })),
    };
  } catch (error: unknown) {
    return rejectWithValue(toApiError(error, "Failed to check for conflicts"));
  }
});
